/* eslint-disable react-hooks/exhaustive-deps */
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { LoadingButton } from "@mui/lab";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";

import { Title } from "@/components/title/style";
import { toast } from "react-toastify";
import serviceModeloFatura from "@/services/serviceModeloFatura";
import messages from "@/utils/messages";
import { ChipData, createChipDataWithKeys, generateUniqueKey, stringFormulaToArray, validateFormula } from "./utils";

export interface IDialogProps {
    open: boolean;
    data: any;
    descricaoFaturaValoresDataOptions: any;
    onSuccess: () => void;
    onClose: any;
}
const Modal: React.FC<IDialogProps> = ({ open, data, descricaoFaturaValoresDataOptions, onClose, onSuccess }) => {
    const [isDisable, setDisable] = useState(false);
    const [chipData2, setChipData2] = React.useState<readonly ChipData[]>([]);

    useEffect(() => {
        if (open && data.formula) {
            setChipData2(
                stringFormulaToArray(data.formula).map((value) => {
                    return { label: value, key: generateUniqueKey() };
                })
            );
        }
    }, [open]);

    const [chipData] = React.useState<readonly ChipData[]>(
        createChipDataWithKeys(["+", "-", "/", "*", "[", "]", "(", ")"])
    );

    const fieldOptions = createChipDataWithKeys(descricaoFaturaValoresDataOptions?.map((value) => value.label));

    const handleAddOperation = (chipToAdd: ChipData) => () => {
        setChipData2((prevChips) => [...prevChips, { ...chipToAdd, key: generateUniqueKey() }]);
    };

    const handleDelete = (chipToDelete: ChipData) => () => {
        setChipData2((prevChips) => prevChips.filter((chip) => chip.key !== chipToDelete.key));
    };

    const isField = (token: string) => descricaoFaturaValoresDataOptions?.map((value) => value.label).includes(token);

    const onSubmit = () => {
        setDisable(true);
        const isValid = validateFormula(chipData2, isField);

        if (!isValid) {
            setDisable(false);
            return toast.error("Fórmula de Cálculo Inválida!");
        }

        serviceModeloFatura
            .updatePosicao({
                faturaPosicaoId: data.faturaPosicaoId,
                formula: chipData2.map((value) => value.label),
            })
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose();
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <Box>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setChipData2([]);
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <Title>Editar Fórmula do Campo</Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            setChipData2([]);
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        onSubmit();
                    }}
                >
                    <DialogContent dividers>
                        <Grid container columns={16}>
                            <Grid item xs={6} md={6} sx={{ pr: 2, borderRight: "1px solid rgba(0, 0, 0, 0.12)" }}>
                                <Typography variant="h5" mb={1} mt={0}>
                                    Selecione os campos:
                                </Typography>
                                <Autocomplete
                                    disablePortal
                                    id="descricaoFaturaValoresId"
                                    options={fieldOptions}
                                    getOptionLabel={(option) => option.label}
                                    sx={{
                                        p: 0,
                                        "& input": {
                                            height: 16,
                                        },
                                    }}
                                    onChange={(event, value) => {
                                        if (value) {
                                            handleAddOperation(value)();
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            <Grid item xs={10} md={10} sx={{ pl: 2 }}>
                                <Typography variant="h5" mb={1}>
                                    Operações:
                                </Typography>
                                <Paper
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexWrap: "wrap",
                                        p: 0.5,
                                        mb: 1,
                                    }}
                                >
                                    {chipData.map((data) => {
                                        return (
                                            <Chip
                                                sx={{ margin: 0.5 }}
                                                label={data.label}
                                                clickable
                                                onClick={handleAddOperation(data)}
                                            />
                                        );
                                    })}
                                </Paper>
                                <Divider />
                                <Typography variant="h5" mt={1}>
                                    Fórmula:
                                </Typography>
                                <Paper
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        flexWrap: "wrap",
                                        minHeight: 40,
                                        p: 0.5,
                                        m: 0,
                                        mt: 1,
                                    }}
                                >
                                    {chipData2.map((data) => {
                                        return (
                                            <Chip
                                                sx={{ margin: 0.5 }}
                                                label={data.label}
                                                clickable
                                                onClick={handleDelete(data)}
                                            />
                                        );
                                    })}
                                </Paper>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={() => {
                                setChipData2([]);
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <LoadingButton
                            type="submit"
                            color="primary"
                            variant="contained"
                            loading={isDisable}
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </Box>
    );
};

export default Modal;
